import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { SKILLS, FACTS, PROFILE } from '../data/config';
import headShot from '../assets/headShot.jpeg';

const AboutContent = () => {
  const [currentFact, setCurrentFact] = useState(0);

  return (
    <div className="about-content">
      <div className="about-header">
        <div className="about-avatar-container">
          <img src={headShot} alt="Ossama" className="about-avatar" />
          <div className="avatar-scanlines" />
        </div>
        <div className="about-info">
          <h2>{PROFILE.name}</h2>
          <p className="about-title">{PROFILE.title}</p>
          <p className="about-location"><MapPin size={14} strokeWidth={1.5} /> {PROFILE.location}</p>
        </div>
      </div>

      <div className="about-bio">
        <p>{PROFILE.bio}</p>
      </div>

      <div className="fact-rotator">
        <span className="fact-label">{'// random_fact.txt'}</span>
        <motion.p
          key={currentFact}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="fact-text"
        >
          {FACTS[currentFact]}
        </motion.p>
        <button
          className="fact-btn"
          onClick={() => setCurrentFact((currentFact + 1) % FACTS.length)}
        >
          [NEXT FACT]
        </button>
      </div>

      <div className="skills-section">
        <h3>{'// skills.dll'}</h3>
        <div className="skill-tags">
          {SKILLS.map(skill => (
            <span key={skill} className="skill-tag">{skill}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
